/**
 * Transport Status Component
 * 
 * Shows the current transport mode:
 * - HTTP Polling (fallback mode)
 * - WebTransport (real-time mode)
 * - Disconnected (connecting/error)
 */

import { useTransportMode } from '../hooks/useHttpPolling';

const NETWORK = import.meta.env.VITE_NETWORK || 'alpha-devnet';

export default function TransportStatus() {
  const { mode, state } = useTransportMode();
  
  const getStatusColor = () => {
    switch (mode) {
      case 'webtransport':
        return 'var(--success)';
      case 'http-polling':
        return 'var(--warning, #f59e0b)';
      case 'disconnected':
        return 'var(--error, #ef4444)';
    }
  };
  
  const getStatusLabel = () => {
    switch (mode) {
      case 'webtransport':
        return 'WebTransport';
      case 'http-polling':
        return 'HTTP Polling';
      case 'disconnected':
        return state === 'connecting' ? 'Connecting...' : 'Disconnected';
    }
  };
  
  const getStatusIcon = () => {
    switch (mode) {
      case 'webtransport':
        return '⚡'; // Fast real-time
      case 'http-polling':
        return '🔄'; // Polling
      case 'disconnected':
        return '●';  // Dot for disconnected
    }
  };
  
  return (
    <div 
      className="transport-status"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        fontSize: '12px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span style={{ color: getStatusColor() }}>{getStatusIcon()}</span>
        <span style={{ color: getStatusColor(), fontWeight: 500 }}>
          {getStatusLabel()}
        </span>
      </div>
      <div style={{ 
        color: 'var(--text-secondary, #9ca3af)', 
        fontSize: '11px',
      }}>
        ({NETWORK})
      </div>
    </div>
  );
}
